module.exports = __webpack_public_path__ + "img/Tail lamp.fe065c04.jpg";